import { Company, CompanyFormValues } from '@common/types/company.types'
import { get, post } from '@common/utils/request.utils'

type CompanyApiRequests = {
	getCompanies: (query?: string) => Promise<Company[]>
	createCompany: (formValues: CompanyFormValues) => Promise<Company>
}

const COMPANY_API_URL = '/companies'

/**
 * Company api requests
 */
export const useCompanyApi = (): CompanyApiRequests => {
	const getCompanies = (query: string = ''): Promise<Company[]> => {
		const params = new URLSearchParams({ query })
		return get(`${COMPANY_API_URL}?${params}`)
	}

	const createCompany = (formValues: CompanyFormValues): Promise<Company> => {
		return post(
			COMPANY_API_URL,
			JSON.stringify(formValues)
		)
	}

	return {
		getCompanies,
		createCompany
	}
}
